import { useRouter } from 'next/router'

import { useAppDispatch } from '~/redux/hooks'
import ROUTES from '~/shared/constants/routes.const'
import { useSetRetakeExamMutation } from '~/tests/apis/exams.api'
import {
  setCurrentQuestionIndexActionCreator,
  setFilterDataActionCreator,
  setQuestionsActionCreator,
  setShouldShowTimeTrackerActionCreator,
  setStartTimeActionCreator,
} from '~/tests/slice/testPrep.slice'
import testPrepAnalytics from '~/tests/hooks/testPrepAnalytics'

export default function useRetakeExam(): (examId: number) => Promise<void> {
  const router = useRouter()
  const dispatch = useAppDispatch()
  const [setRetakeExam] = useSetRetakeExamMutation()

  const handleRetakeClick = async (examId: number): Promise<void> => {
    dispatch(setQuestionsActionCreator({ id: null, testId: null, questions: [] }))
    const resp = await setRetakeExam({ examId }).unwrap()
    const { id, testId: retakeTestId, questions, filterData } = resp
    dispatch(setFilterDataActionCreator(filterData))
    dispatch(setQuestionsActionCreator({ id, testId: retakeTestId, questions }))
    dispatch(setShouldShowTimeTrackerActionCreator(filterData.limitBy.time >= 0))
    dispatch(setStartTimeActionCreator(Date.now()))
    dispatch(setCurrentQuestionIndexActionCreator(0))
    testPrepAnalytics.logCtaClick(`retake_button`, `retake_button_click_for_test_${examId}`)
    router.replace(ROUTES.TEST_EXAM)
  }

  return handleRetakeClick
}
